/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AssessmentAnswer from './assessment-answer';
import AssessmentAnswerDetail from './assessment-answer-detail';
import AssessmentAnswerUpdate from './assessment-answer-update';
import AssessmentAnswerDeleteDialog from './assessment-answer-delete-dialog';

const AssessmentAnswerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AssessmentAnswer />} />
    <Route path="new" element={<AssessmentAnswerUpdate />} />
    <Route path=":id">
      <Route index element={<AssessmentAnswerDetail />} />
      <Route path="edit" element={<AssessmentAnswerUpdate />} />
      <Route path="delete" element={<AssessmentAnswerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AssessmentAnswerRoutes;
